// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_container {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(120deg, rgb(39, 6, 45) 30%, rgb(60, 30, 95) 60%, rgb(9, 23, 51) 100%);
  display: flex;
}
.login_container .left_side {
  width: 60%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 10rem;
}
.login_container .left_side .welcome_text {
  color: #FFFFFF;
}
.login_container .left_side .subtext {
  width: 50%;
  color: #FFFFFF;
  font-size: 0.8rem;
  margin-top: 0.5rem;
}
.login_container .right_side {
  width: 40%;
  height: 100vh;
  display: flex;
  align-items: center;
}
.login_container .right_side .login_section {
  width: 80%;
  background-color: #463B4D;
  padding: 1.6rem 0;
  border-radius: 0.8rem;
  font-size: 80%;
}
.login_container .right_side .login_section h2 {
  padding: 0 0 1.6rem 1.5rem;
  font-size: 1.8rem;
  color: #FFFFFF;
}
.login_container .right_side .login_section .login_form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 1.2rem;
}
.login_container .right_side .login_section .login_form input {
  padding: 0.8rem;
  font-size: 1rem;
  outline: none;
  border: 1px solid #DCDCDC;
  border-radius: 0.3rem;
  color: #DCDCDC;
  background-color: #463B4D;
}
.login_container .right_side .login_section .login_form input::placeholder {
  color: #c0bfbf;
}
.login_container .right_side .login_section .login_form .input_block {
  display: flex;
  justify-content: space-between;
}
.login_container .right_side .login_section .login_form .input_block input {
  width: 45%;
}
.login_container .right_side .login_section .login_form .password_block {
  width: 100%;
  position: relative;
}
.login_container .right_side .login_section .login_form .password_block input {
  width: 100%;
}
.login_container .right_side .login_section .login_form .password_block .hide_password {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 1.5rem;
  font-size: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #DCDCDC;
}
.login_container .right_side .login_section .login_form .password_block .hide_password:hover {
  color: #eae8e8;
}
.login_container .right_side .login_section .login_form button {
  padding: 0.8rem 0;
  border-radius: 0.8rem;
  outline: none;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: #775DA6;
  font-size: 1rem;
  color: #FFFFFF;
  cursor: pointer;
}
.login_container .right_side .login_section .login_form button:hover {
  background: #9474d0;
}
.login_container .right_side .login_section .signup_success .signup_valid {
  width: 8rem;
  height: 8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.5rem;
  color: #DCDCDC;
  background: linear-gradient(141.82deg, #3B2063 13.67%, #ED1E79 84.68%);
  margin: 0 auto;
  border-radius: 50%;
  animation: signed 0.3s linear forwards;
}
.login_container .right_side .login_section .signup_success h2 {
  margin: 0.5rem auto;
  text-align: center;
  color: #DCDCDC;
}
.login_container .right_side .login_section .signup_success p {
  text-align: center;
  color: #DCDCDC;
  font-size: 1rem;
}
.login_container .right_side .login_section .signup_success .login_btn {
  display: block;
  margin: 1rem auto;
  width: 70%;
  text-decoration: none;
  background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);
  border: 1px solid rgba(255, 255, 255, 0.1490196078);
  text-align: center;
  border-radius: 0.3rem;
  color: #DCDCDC;
  font-size: 1rem;
  font-weight: 600;
  padding: 1rem 0;
}

@keyframes signed {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/signup/_SignUp.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,aAAA;EAKA,iGAAA;EAMA,aAAA;AAVJ;AAYI;EACI,UAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAVR;AAYQ;EACI,cAAA;AAVZ;AAaQ;EACI,UAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAXZ;AAeI;EACI,UAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;AAbR;AAeQ;EACI,UAAA;EACA,yBAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;AAbZ;AAeY;EACI,0BAAA;EACA,iBAAA;EACA,cAAA;AAbhB;AAgBY;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AAdhB;AAgBgB;EACI,eAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,yBAAA;AAdpB;AAgBoB;EACI,cAAA;AAdxB;AAkBgB;EACI,aAAA;EACA,8BAAA;AAhBpB;AAkBoB;EACI,UAAA;AAhBxB;AAoBgB;EACI,WAAA;EACA,kBAAA;AAlBpB;AAoBoB;EACI,WAAA;AAlBxB;AAqBoB;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EAAc,uBAAA;EACd,mBAAA;EACA,eAAA;EACA,cAAA;AAlBxB;AAoBwB;EACI,cAAA;AAlB5B;AAuBgB;EACI,iBAAA;EACA,qBAAA;EACA,aAAA;EACA,2CAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AArBpB;AAuBoB;EACI,mBAAA;AArBxB;AA4BgB;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,sEAAA;EACA,cAAA;EACA,kBAAA;EACA,sCAAA;AA1BpB;AA6BgB;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;AA3BpB;AA8BgB;EACI,kBAAA;EACA,cAAA;EACA,eAAA;AA5BpB;AA+BgB;EACI,cAAA;EACA,iBAAA;EACA,UAAA;EACA,qBAAA;EACA,6DAAA;EACA,mDAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AA7BpB;;AAoCA;EACI;IACI,mBAAA;EAjCN;EAkCI;IACE,mBAAA;EAhCN;AACF","sourcesContent":["\n\n.login_container {\n    width: 100vw;\n    height: 100vh;\n    // background-color: #151018;\n    // background-image: url('../../assets/background.png');\n    // background-repeat: no-repeat;\n    // background-size: cover;\n    background: linear-gradient(\n        120deg, \n        rgba(39, 6, 45, 1) 30%, \n        rgba(60, 30, 95, 1) 60%, \n        rgba(9, 23, 51, 1) 100%\n      );\n    display: flex;\n\n    .left_side {\n        width: 60%;\n        height: 100vh;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        padding-left: 10rem;\n\n        .welcome_text {\n            color: #FFFFFF;\n        }\n\n        .subtext {\n            width: 50%;\n            color: #FFFFFF;\n            font-size: .8rem;\n            margin-top: .5rem;\n        }\n    }\n\n    .right_side {\n        width: 40%;\n        height: 100vh;\n        display: flex;\n        align-items: center;\n\n        .login_section {\n            width: 80%;\n            background-color: #463B4D;\n            padding: 1.6rem 0;\n            border-radius: .8rem;\n            font-size: 80%;\n\n            h2 {\n                padding: 0 0 1.6rem 1.5rem;\n                font-size: 1.8rem;\n                color: #FFFFFF;\n            }\n\n            .login_form {\n                display: flex;\n                flex-direction: column;\n                gap: 1rem;\n                padding: 0 1.2rem;\n\n                input {\n                    padding: .8rem;\n                    font-size: 1rem;\n                    outline: none;\n                    border: 1px solid #DCDCDC;\n                    border-radius: .3rem;\n                    color: #DCDCDC;\n                    background-color: #463B4D;\n\n                    &::placeholder {\n                        color: #c0bfbf;\n                    }\n                }\n\n                .input_block{\n                    display: flex;\n                    justify-content: space-between;\n\n                    input{\n                        width: 45%;\n                    }\n                }\n\n                .password_block{\n                    width: 100%;\n                    position: relative;\n\n                    input{\n                        width: 100%;\n                    }\n\n                    .hide_password{\n                        position: absolute;\n                        top: 50%;\n                        transform: translateY(-50%);\n                        right: 1.5rem;\n                        font-size: 1.5rem;\n                        display: flex;justify-content: center;\n                        align-items: center;\n                        cursor: pointer;\n                        color: #DCDCDC;\n\n                        &:hover {\n                            color: #eae8e8;\n                        }\n                    }\n                }\n\n                button {\n                    padding: .8rem 0;\n                    border-radius: .8rem;\n                    outline: none;\n                    border: 1px solid rgba(255, 255, 255, 0.15);\n                    background: #775DA6;\n                    font-size: 1rem;\n                    color: #FFFFFF;\n                    cursor: pointer;\n\n                    &:hover {\n                        background: #9474d0;\n                    }\n                }\n            }\n\n            .signup_success{\n\n                .signup_valid{\n                    width: 8rem;\n                    height: 8rem;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    font-size: 2.5rem;\n                    color: #DCDCDC;\n                    background: linear-gradient(141.82deg, #3B2063 13.67%, #ED1E79 84.68%);\n                    margin: 0 auto;\n                    border-radius: 50%;\n                    animation: signed .3s linear forwards;\n                }\n\n                h2{\n                    margin: .5rem auto;\n                    text-align: center;\n                    color: #DCDCDC;\n                }\n\n                p{\n                    text-align: center;\n                    color: #DCDCDC;\n                    font-size: 1rem;\n                }\n\n                .login_btn{\n                    display: block;\n                    margin: 1rem auto;\n                    width: 70%;\n                    text-decoration: none;\n                    background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);\n                    border: 1px solid #FFFFFF26;\n                    text-align: center;\n                    border-radius: .3rem;\n                    color: #DCDCDC;\n                    font-size: 1rem;\n                    font-weight: 600;\n                    padding: 1rem 0;\n                }\n            }\n        }\n    }\n}\n\n@keyframes signed {\n    from {\n        transform: scale(0);\n    } to {\n        transform: scale(1);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
